import * as React from 'react';

import {LabelWithContent} from '../typography/label-with-content';

import styles from './recent-submissions.module.css';

type Props = {
    exampleValues: string;
    displayVertically?: boolean;
};

export function RecentSubmissions(props: Props) {
    return (
        <LabelWithContent
            label='Recent submissions'
            content={
                <div
                    className={
                        props.displayVertically
                            ? styles['recent-submissions-container--vertical']
                            : styles['recent-submissions-container']
                    }
                >
                    {props.displayVertically
                        ? props.exampleValues.split(', ').map((exampleValue) => (
                              <div key={exampleValue} className={styles['recent-submissions']}>
                                  {exampleValue}
                              </div>
                          ))
                        : props.exampleValues}
                </div>
            }
        />
    );
}
